const categoryTopics = {
  "en": {
    productReleases: "product-releases",
    forDevelopers: "for-developers",
    forBusiness: "for-business",
    forEducation: "for-education",
  },
  "fr": {
    productReleases: "mises-a-jour-des-produits-fr",
    forDevelopers: "pour-les-developpeurs-fr",
    forBusiness: "pour-les-entreprises-fr",
    forEducation: "pour-education-fr",
  },
  "de": {
    productReleases: "veroeffentlichungen",
    forDevelopers: "entwicklung",
    forBusiness: "business",
    forEducation: "bildung",
  },
  "es": {
    productReleases: "lanzamientos-de-productos",
    forDevelopers: "para-desarrolladores",
    forBusiness: "para-empresas",
    forEducation: "para-la-educacion",
  },
  "pt-br": {
    productReleases: "lancamentos-de-produtos",
    forDevelopers: "para-desenvolvedores",
    forBusiness: "para-negocios",
    forEducation: "para-educacao",
  },
  "it": {
    productReleases: "rilascio-dei-prodotti",
    forDevelopers: "per-gli-sviluppatori",
    forBusiness: "per-affari",
    forEducation: "per-l-istruzione",
  },
  "cs": {
    forBusiness: "pro-firmy",
  },
  "ja": {
    productReleases: "product-releases-ja",
    forDevelopers: "for-developers-ja",
    forBusiness: "for-business-ja",
    forEducation: "for-education-ja",
  },
  "zh-hans": {
    productReleases: "product-releases-zh-hans",
    forDevelopers: "for-developers-zh-hans",
    forBusiness: "for-business-zh-hans",
    forEducation: "for-education-zh-hans",
  },
  "el": {
    productReleases: "product-releases-el",
    forDevelopers: "for-developers-el",
    forBusiness: "for-business-el",
    forEducation: "for-education-el",
  },
  "hi": {
    productReleases: "product-releases-hi",
    forDevelopers: "for-developers-hi",
    forBusiness: "for-business-hi",
    forEducation: "for-education-hi",
  },
  "ar": {
    productReleases: "product-releases",
    forDevelopers: "for-developers",
    forBusiness: "for-business",
    forEducation: "for-education",
  },
  "sr": {
    productReleases: "product-releases-sr",
    forDevelopers: "for-developers-sr",
    forBusiness: "for-business-sr",
    forEducation: "for-education-sr",
  },
  "hy": {
    productReleases: "product-releases-hy",
    forDevelopers: "for-developers-hy",
    forBusiness: "for-business-hy",
    forEducation: "for-education-hy",
  },
};

export default categoryTopics;
